import { AppRepository } from '../app-repository';
import { Repository } from 'aurelia-orm';

export class ItemRepository extends AppRepository {

}